<template>
  <div class="home">
    <Scrollama :offset="0.66" :progress="true" @step-enter="stepEnter" @step-exit="stepExit">
      <!-- <div class="portfolio-hero hero wrap-full">
        <div class="hero__video stickToHeader" ref="heroVideoStyle" slot="graphic">
          <div class="video-wrapper">
            <video loading="lazy" ref="heroVideo" id="heroVideo" autoplay muted="muted">
              <source type="video/mp4">
            </video>
          </div>
          <div class="row">
            <div class="column medium-6 small-6 hero-image-wrapper">
              <img src="https://framerusercontent.com/images/2gZEyMLTTMZmCifnemOr7Lxdnk4.png">
            </div>
            <div class="row column medium-6 small-6">
              <div class="column medium-6 small-12">
                <div class="title-wrapper">
                <h2 class="animate__first" style="margin: 1rem">Interface Designer <br> Design Technologist.</h2>
                <h3 class="animate__second paragraph">p</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div> -->
      <div class="overlay__background" ref="videoArrows">
        <img src="/assets/img/dotmatrix.svg">
      </div>
    </Scrollama>
    <div class="work" id="projects">
      <div class="project-selector">
        <ProjectSelector id="projects" class="desktop"></ProjectSelector>
        <ProjectSelectorMobile id="projects" class="mobile"></ProjectSelectorMobile>
        <div class="image-preview">
          <!-- <ProjectPreview v-if="currentProject" :currentProject=this.currentProject></ProjectPreview> -->
        </div>
      </div>
    </div>
    <side-projects></side-projects>
    <about id="about"></about>

    

    <!-- <ImageSlider>
      <div style="width: 30vw; height: 400px; background-color: pink; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: blue; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: green; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: blue; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: green; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: green; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: blue; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: green; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: pink; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: brown; flex-shrink:0;"></div>
      <div style="width: 30vw; height: 400px; background-color: yellow; flex-shrink:0;"></div>
    </ImageSlider> -->
    
    <vitae></vitae>
  </div>
  
</template>

<script>
  import HeadlineWithLine from '@/components/typography/HeadlineWithLine'
  import ProjectPreview from '@/components/modules/ProjectPreview'
  import ProjectSelector from '@/components/modules/ProjectSelector'
  import ProjectSelectorMobile from '@/components/modules/ProjectSelectorMobile'
  import SideProjects from '@/components/modules/SideProjects'
  import ImageSlider from '@/components/ImageSlider'

  import About from '@/views/About.vue'
  import Vitae from '@/views/Vitae.vue'

  import 'intersection-observer' // for cross-browser support
  import Scrollama from 'vue-scrollama'

  import {
    mapState
  } from 'vuex'

  import Vuex from 'vuex'

  // @ is an alias to /src
  export default {
    components: {
      HeadlineWithLine,
      ProjectPreview,
      ProjectSelector,
      ProjectSelectorMobile,
      SideProjects,
      Scrollama,
      ImageSlider,
      About,
      Vitae
    },
    data() {
      return {
        currentProject: Object,
        underlinedElements: []
      }
    },
    computed: {
      /* Using the namespace in mapState */
      ...mapState([
        'projects'
      ])
    },
    mounted() {
      this.$refs.heroVideo.src = "/assets/video/self.sequence.mp4";
      this.$refs.heroVideo.play();
    },
    methods: {
      stepEnter({
        element
      }) {
        let video = this.$refs.heroVideoStyle;
        let videoArrows = this.$refs.videoArrows;
        // video.classList.remove("stickToHeader")
        videoArrows.classList.add("show")
      },
      stepExit({
        element,
        index,
        direction
      }) {
        let video = this.$refs.heroVideoStyle;
        let videoArrows = this.$refs.videoArrows;
        videoArrows.classList.remove("show")
        // let leftOffset = document.querySelector(".navbar").offsetLeft
        // console.log(leftOffset)
        // video.classList.add("stickToHeader")
        // video.style.left = leftOffset.toString() + "px"
      },
      handleProject() {
        console.log(this.$store.state.fuck)
      },
      handleProjectChange: function (currentProject, event) {
        this.currentProject = this.projects[currentProject.meta.id - 1]

        // console.log(event);
      }
    }



  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/base.scss';

  .desktop {
    display: flex;

    @include touch-device () {
      display: none !important;
    }
  }

  .mobile {
    display: none;

    @include touch-device () {
      display: block !important;
    }
  }
</style>

<style lang="scss">
  @import '../assets/scss/base.scss';

  .home {
    border-bottom: 3rem solid $dark;
  }

  .portfolio-hero {
    position: relative;
    top: 0;
    height: 100%;
    min-height: 100%;

    @include md () {
      height: auto;
    }

    overflow: hidden;

    #heroVideo {
      border-radius: 8px;
    }

    video {
      overflow: none;
      width: 100%;
    }

    // &:after {
    //   content: '';
    //   position: absolute;
    //   display: block;
    //   height: 280%;
    //   width: 600%;
    //   animation: grain 8s steps(10) infinite;
    //   position: absolute;
    //   top: -100%;
    //   left: -50%;
    //   opacity: 0.1;
    //   // background-image: url('/assets/img/textures/paper_1.png');
    // }
  }

  @keyframes grain {

    0%,
    100% {
      transform: translate(0, 0)
    }

    10% {
      transform: translate(-5%, -10%)
    }

    20% {
      transform: translate(-15%, 5%)
    }

    30% {
      transform: translate(7%, -25%)
    }

    40% {
      transform: translate(-5%, 25%)
    }

    50% {
      transform: translate(-15%, 10%)
    }

    60% {
      transform: translate(15%, 0%)
    }

    70% {
      transform: translate(0%, 15%)
    }

    80% {
      transform: translate(3%, 35%)
    }

    90% {
      transform: translate(-10%, 10%)
    }
  }
</style>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style lang="scss">
  @import '../assets/scss/base.scss';

  .overlay__background {
    position: absolute;
    top: 2vw;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: $t5 $out-quart;
    transform: translateZ(-20rem) rotateX(12deg) scale(.98);
    img {
      object-fit: cover;
      height: 100%;
    }

    &.show {
      opacity: .2;
      transform: translateZ(0) rotateX(0) scale(1);
    }
  }

  .hero {
    display: flex;
    justify-content: center;

    &__overlay {
      position: relative;
      top: 55%;
      height: 25%;
      border-radius: 12px;
      z-index: 10;

      @include md() {
        margin-top: 50vh;
      }

    }

    &__video {
      display: grid;
      flex-direction: column;
      top: 50%;
      left: 50%;
      width: 100%;
      // max-width: 50vw;
      // transform: scaleX(1) scaleY(1) scaleZ(1) translateX(-50%) translateY(-50%) translateZ(63px) skewX(0deg) skewY(0deg);
      transition: 0.3s cubic-bezier(0.45, 0, 0.55, 1);
      transform-origin: top left;
      filter: contrast(0.9) brightness(0.8) opacity(90%);

      .video-wrapper {
        height: auto;
        overflow: hidden;
        object-fit: cover;
        border-radius: 8px;
        display: flex;
        align-items: center;
      }

      .hero-image-wrapper {
        display: flex;
        width: 100%;
        justify-content: center;  /* Center the image horizontally */
        align-items: center;      /* Center the image vertically */

        
        img {
          width: auto;
          max-width: 42rem;
          height: auto;
          max-height: 100%;  /* Optionally limit the height to the height of the container */
          border-radius: 8px;
        }
      }



      &.stickToHeader {
        padding: 2rem 0;
        z-index: 1;
        filter: none;

        display: grid;
        justify-content: center;
        align-items: center;
      }

      .title-wrapper {
        display: flex;
        gap: 4rem;
        @include md () {
          flex-direction: column;
        }
      }

      h2.animate__first {

        animation: 450ms reveal cubic-bezier(0.335, 0.095, 0.27, 0.8);
  
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-delay: 1200ms;
        opacity: 0;
        font-size: 2.25rem;

        @include md () {
          font-size: 1.75rem;
          text-align: center;
        }

        &:after {
          content: '';
          position: relative;
          display: block;
          width: 10rem;
          height: 2px;
          left: 50%;
          top: 0.5rem;
          transform: translateX(-50%);
          background: $white-100;
          animation: 650ms line-reveal $out-quart;
          animation-delay: 1600ms;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          clip-path: inset(0 100% 0 0);
        }
      }

      h3.animate__second {
        text-align: left;
        animation: 450ms reveal cubic-bezier(0.335, 0.095, 0.27, 0.8);
        ;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-delay: 1700ms;
        opacity: 0;
        margin: 2rem auto;
        font-size: 1.2rem;

        @include md() {
          text-align: left;
          font-size: 1.25rem;
        }
      }

      // background: rgba(255, 255, 255, .15);
      padding: 0 2.5rem;
      text-align: center;

      h2 {
        font-size: 3rem;
        margin: 1.825rem auto 0 auto ;
        color: $light;
        max-width: 85ch;
      }

      h3 {
        margin: 2rem 0;
        color: $light;
        max-width: 55ch;
      }
    
    }
  }

  .projects {
    .project-selector {
      width: 100%;
      height: 100%;

      a {
        text-decoration: none;
      }

      .image-preview {
        position: relative;
        height: 40vh;
        width: 45%;
        z-index: -1;

        .background {
          position: absolute;
          z-index: -10;
          top: 0;
          width: 100%;
          height: 100%;
          background-size: cover !important;
          transition: all 450ms cubic-bezier(0.335, 0.095, 0.27, 0.8);
          ;
        }
      }

      .selector-wrapper {
        display: flex;
        flex-direction: column;
        width: 55%;
        padding: 0 1.5rem;
        height: 100vh;
        align-items: flex-start;
        justify-content: center;
        background: #F0F7FD;

        .entry {
          width: 100%;
          padding: 2rem 1.5rem 2.75rem 1.5rem;
          margin: 0 0 1rem 0;
          border-radius: 8px;
          transition: 350ms ease-out;
          background: #F6FBFF;
          border: 1px solid transparent;

          &:hover {
            background: #fff;
            border-radius: 8px;
            border: 1px solid #D0E9FE;

            .content {
              opacity: 1;
              padding-top: 8px;
              max-height: 600px;
            }
          }

          .head {
            display: flex;
            align-items: baseline;
          }

          .content {
            opacity: 0;
            max-height: 0;
            overflow: hidden;
            transition: 350ms ease-out;

            p {
              font-family: "Inter";
              color: #424242;

              &:first-child {
                margin: -.75rem 0 0 7rem;
              }

              &.badge {
                font-family: "Inter";
                margin: .75rem 0 0 7.75rem;

                &:before {
                  content: '';
                  display: inline-block;

                  position: relative;
                  top: 0.5rem;
                  right: .75rem;

                  width: 22px;
                  height: 22px;

                  border: 5px solid #A1C882;
                  border-radius: 50%;

                  background: linear-gradient(#A1C882, #DFFEC6);
                }
              }
            }

          }

          cursor: pointer;

          h1 {
            font-size: 2.75rem;
            font-family: "Inter";
            color: #424242;
          }

          h4 {
            padding-left: 0.5rem;
            color: #424242;
          }

          span {
            font-family: "Inter";
            font-size: 1.5rem;
            padding-right: 5.5rem;
            color: #9DADBA;
          }
        }
      }
    }
  }
</style>